import {AxiosPromise} from 'axios'
import Client from 'core/api/client'

export function logout(token: string): AxiosPromise {
  const headers = { Authorization: `Bearer ${token}` }
  return Client.post('/study/coordinator/auth/logout', undefined, { headers })
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_coordinator/logout.ts